export const BASE_LENGTH = 800;